import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import BMYForm from '../BMYForm';
import VesselForm from '../VesselForm';
import ConfigurationForm from '../ConfigurationForm';
import Page from '../Page';
import PageSection from '../PageSection';
import CustomerInfo from '../CustomerInfo';
import ButtonGroup from '../ButtonGroup';
import Popup from '../Popup';
import Select from '../Select';
import SizingChart from '../../utils/SizingChart';
import queryString from 'query-string';
var LineChart = require("react-chartjs").Line;

var Auth = new AuthService();

var initialBuilderInfo = {
	selectedId: null,
	selectedText: ""
};

var initialModelInfo = {
	selectedId: null,
	selectedText: ""
};

var initialVesselInfo = {
	hullName: "",
	application: "",
	vesselUse: "",
	hullType: "",
	vesselInstallation: "",
	appendages: "",
	waterlineTransom: "",
	deadriseBwl: "",
	deadriseTransom: "",
	naturalRollPeriod: "",
	operationHours: "",
	demoHullMaxBWL: "",
	demoHullSpacingBWL: "",
	notes: ""
};

var initialConfigInfo = [
	{
		title: 'Configuration 1',
		seakeeperData: [
			{
				seakeeperModel: "",
				numGyros: ""
			}
		]
	}
];

const validationObject = [
	{
		"parent": "bmyInfo",
		"fieldName": "bmy_id",
		"required": true,
		"errorMessage": "Builder, Model, and Year"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "application",
		"required": true,
		"errorMessage": "Application"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "vesselUse",
		"required": true,
		"errorMessage": "Vessel Use"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "subApplication",
		"required": true,
		"errorMessage": "Sub-Application"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "hullType",
		"required": true,
		"errorMessage": "Hull Type"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "vesselInstallation",
		"required": true,
		"errorMessage": "Vessel Installation"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "fullLoad",
		"required": true,
		"errorMessage": "Full Load Displacement"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "LOA",
		"required": true,
		"errorMessage": "Length Overall"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "LWL",
		"required": true,
		"errorMessage": "Waterline Length"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "BOA",
		"required": true,
		"errorMessage": "Beam Overall"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "BWL",
		"required": true,
		"errorMessage": "Max Waterline Beam"
	},
	{
		"fieldName": "selectedSalesUser",
		"required": true,
		"errorMessage": "Sales Representative"
	}
];

// Auth logic with routes from this example:
// https://reacttraining.com/react-router/web/example/auth-workflow
class SizingForm extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();
		this.chartData = {
			labels: ["0°", "", "", "", "", "5°", "", "", "", "", "10°", "", "", "", "", "15°", "", "", "", "", "20°", "", "", "", "", "25°"],
			datasets: [
				{
					label: "Configuration 1",
					fillColor: "transparent",
					strokeColor: "#01a8e0",
					pointHighlightFill: "#01a8e0",
					data: [0,0,0,0,0,0]
				},
				{
					label: "Configuration 2",
					fillColor: "transparent",
					strokeColor: "#9BA5AE",
					pointHighlightFill: "#9BA5AE",
					data: [0,0,0,0,0,0]
				},
				{
					label: "Configuration 3",
					fillColor: "transparent",
					strokeColor: "#031D40",
					pointHighlightFill: "#031D40",
					data: [0,0,0,0,0,0]
				},
				{
					label: "Configuration 4",
					fillColor: "transparent",
					strokeColor: "#A9CEF4",
					pointHighlightFill: "#A9CEF4",
					data: [0,0,0,0,0,0]
				},
				{
					label: "Configuration 5",
					fillColor: "transparent",
					strokeColor: "#5677b6",
					pointHighlightFill: "#5677b6",
					data: [0,0,0,0,0,0]
				}
			]
		};
		this.validationObject = validationObject;

		this.state = {
			sizingFormId: null,
			bmyInfo: {},
			builderInfo: initialBuilderInfo,
			modelInfo: initialModelInfo,
			year: "",
			vesselInfo: initialVesselInfo,
			configInfo: initialConfigInfo,
			disableAddConfiguration: false,
			customerInfo: {},
			maxSeakeepers: 3,
			maxConfigs: 3,
			unit: 'Metric',
			disableBMY: false,
			disableVessel: false,
			disableConfig: false,
			canEditSizingForm: false,
			canEditConfigs: false,
			canSubmitForApproval: false,
			canApprove: false,
			canRecommend: false,
			canPublish: false,
			canShowHide: false,
			canEditReportConfigs: false,
			canReject: false,
			canRestore: false,
			showChart: false,
			isEditing: false,
			isEditingConfigs: false,
			isEditingReportConfigs: false,
			isNew: true,
			reportStatus: 0,
			message: false,
			popupCallback: '',
			salesUserList: [],
			selectedSalesUser: 0,
			recommendedConfiguration: null,
			chartData: this.chartData,
			chartOptions: {
				pointDot: false,
				bezierCurveTension : 0.3
			},
			displayChart: false,
			loading: true,
			sizingCalculatorRec: false,
			errors: [],
			hasOverride: false,
			copying: false
		};

		this.vesselForm = null;

		this.setBMY = this.setBMY.bind(this);
		this.validateSizingForm = this.validateSizingForm.bind(this);
		this.submitSizingForm = this.submitSizingForm.bind(this);
		this.updateSizingForm = this.updateSizingForm.bind(this);
		this.vesselInfoChange = this.vesselInfoChange.bind(this);
		this.configInfoChange = this.configInfoChange.bind(this);
		this.loadingButton = this.loadingButton.bind(this);
		this.removeLoadingButton = this.removeLoadingButton.bind(this);
		this.showMessage = this.showMessage.bind(this);
		this.hideMessage = this.hideMessage.bind(this);
		this.hideMessageRedirect = this.hideMessageRedirect.bind(this);
		this.confirmReject = this.confirmReject.bind(this);
		this.calculatePlotData = this.calculatePlotData.bind(this);
		this.isCatamaran = this.isCatamaran.bind(this);

		this.submitForApproval = this.submitForApproval.bind(this);
		this.approveSizingForm = this.approveSizingForm.bind(this);
		this.rejectSizingForm = this.rejectSizingForm.bind(this);
		this.publishSizingForm = this.publishSizingForm.bind(this);
		this.updateRecommendation = this.updateRecommendation.bind(this);
		this.restoreSizingForm = this.restoreSizingForm.bind(this);

		this.createBMY = this.createBMY.bind(this);
		this.changeBuilder = this.changeBuilder.bind(this);
		this.changeModel = this.changeModel.bind(this);
		this.changeYear = this.changeYear.bind(this);
		this.addConfigSeakeeper = this.addConfigSeakeeper.bind(this);
		this.addConfiguration = this.addConfiguration.bind(this);
		this.deleteConfiguration = this.deleteConfiguration.bind(this);
		this.unitChange = this.unitChange.bind(this);
		this.editClick = this.editClick.bind(this);
		this.cancelEdit = this.cancelEdit.bind(this);
		this.copyClick = this.copyClick.bind(this);
		this.copySizingForm = this.copySizingForm.bind(this);

		this.getSalesUsers = this.getSalesUsers.bind(this);
		this.changeSalesUser = this.changeSalesUser.bind(this);
		this.updateRecommendConfig = this.updateRecommendConfig.bind(this);
		this.deleteConfigSeakeeper = this.deleteConfigSeakeeper.bind(this);
		this.configChangeShowHide = this.configChangeShowHide.bind(this);
		this.updateConfigurations = this.updateConfigurations.bind(this);
		this.editConfigurationsClick = this.editConfigurationsClick.bind(this);
		this.editReportConfigsClick = this.editReportConfigsClick.bind(this);

		this.getSalesUsers();
	}

	componentDidMount() {
		const { sizing_form_id } = this.props.match.params;

		console.log('TEST QUERY STRING:');
		console.log(queryString.parse(this.props.location.search));
		let use_bmy = false;
		let qs = queryString.parse(this.props.location.search);
		let cutoffTime = Date.parse('2023-08-16');

		if(qs && qs.bmy) {
			this.Auth.fetch('/bmy/'+qs.bmy)
			.then(
				(result) => {
					console.log(result);
					if(result.success) {
						let userProfile = this.Auth.getProfile();
						// sales and admin roles get pre-populated fields
						if(userProfile.pp_role_id <= 100) {
							this.setBMY(result.bmy);
						} else {
							this.setState({
								bmyInfo: result.bmy
							});
						}
						this.setState({
							builderInfo: {
								selectedId: result.bmy.builder_id,
								selectedText: result.bmy.builder_name
							},
							modelInfo: {
								selectedId: result.bmy.model_id,
								selectedText: result.bmy.model_name
							},
							year: result.bmy.boat_year
						});
					} else {
						if(result.messages) {
							this.showMessage(result.messages.join("\n"));
						}
					}
					let userProfile = this.Auth.getProfile();
					// sales and admin roles can add up to 5 configurations
					if(userProfile.pp_role_id <= 100) {
						this.setState({
							maxConfigs: 5
						});
					}
					this.setState({
						customerInfo: this.Auth.getProfile(),
						canEditConfigs: true,
						loading: false
					});
				},
				(error) => {
					this.setState({
						error
					});
					this.showMessage('Something went wrong. Please try again later.');
				}
			);
		} else if(sizing_form_id) {
			this.Auth.fetch('/prediction/sizing-form/' + sizing_form_id)
			.then(
				(result) => {
					console.log(result);
					if(result.success) {
						let data = result.data,
							newRequirements2023 = false;

						// check configured date
						if (data.configured_date != null && Date.parse(data.configured_date) > cutoffTime) {
							newRequirements2023 = true;
						}

						let userProfile = this.Auth.getProfile();
						// sales and admin roles can add up to 5 configurations
						if(userProfile.pp_role_id <= 100) {
							this.setState({
								maxConfigs: 5
							});
						} else {
							// dealer's won't get notification of overrides
							data.has_override = false;
						}

						// BMY Data
						let tempBMY = {
							bmy_id: data.bmy_id,
							builderId: data.builder_id,
							builderName: data.builder_name,
							modelId: data.model_id,
							modelName: data.model_name,
							year: data.boat_year,
							displacement: data.displacement,
							gmt: data.gmt,
							loa: data.loa,
							lwo: data.lwl,
							boa: data.boa,
							bwl: data.bwl
						};

						// check if sizing calculator applies
						if(data.loa <= 14.934 && userProfile.pp_role_id == 1) {
							let tempSizingChart;

							if(SizingChart[data.sub_application_name]) {
								tempSizingChart = SizingChart[data.sub_application_name];
								let recommended = false;
								let count = tempSizingChart.length;
								search:
								for(let i=0; i<count; i++) {
									console.log(data.boa);
									if(data.boa <= tempSizingChart[i].beam) {
										let count2 = tempSizingChart[i].options.length;
										for(let j=0; j<count2; j++) {
											if(data.loa <= tempSizingChart[i].options[j].maxLength) {
												console.log(tempSizingChart[i].options[j]);
												recommended = tempSizingChart[i].options[j].recommend;
												break search;
											}
										}
									}
								}

								this.setState({
									sizingCalculatorRec: recommended
								});
							}
						}

						// Configuration Data
						let configurations = data.configurations;
						let tempConfigs = [];
						if(configurations) {
							for(let i=0; i<configurations.length; i++) {
								let tempConfig = {
									title: "Configuration " + (i+1),
									index: i,
									seakeeperData: [],
									configID: configurations[i][0].config_id,
									showConfig: configurations[i][0].show_dealer
								};

								if(configurations[i][0].recommended === "1" || configurations[i][0].recommended === 1) {
									this.setState({
										recommendedConfiguration: configurations[i][0].config_id
									});
								}

								for(let j=0; j<configurations[i].length; j++) {
									tempConfig.seakeeperData.push({
										seakeeperModel: configurations[i][j].sk_model_id,
										numGyros: configurations[i][j].sk_model_count
									});
								}
								if(configurations[i].length >= this.state.maxSeakeepers) {
										tempConfig.disableAddSeakeeper = true;
								}
								tempConfigs.push(tempConfig);
							}
						}
						if(tempConfigs.length >= this.state.maxConfigs) {
							this.setState({
								disableAddConfiguration: true
							});
						}

						let province_name =  data.province_abbreviation || data.province_name;

						// Customer Data
						let tempCustomer = {
							first_name: data.first_name,
							last_name: data.last_name,
							company: data.company,
							phone: data.phone,
							street_address: data.street_address,
							city: data.city,
							province_name: province_name,
							postal_code: data.postal_code
						};

						// Status and Permissions
						if(data.report_status == 1) {
							// Status: Created
							// Sales and Admin roles can edit sizing form and configs
							if(userProfile.pp_role_id <= 100) {
								this.setState({
									canEditSizingForm: true,
									canEditConfigs: true,
									canSubmitForApproval: true
								});
							}
						} else if(data.report_status == 2) {
							// Status: Configured
							// Admin role can edit sizing form and configs
							if(userProfile.pp_role_id == 1) {
								this.setState({
									canEditSizingForm: true,
									canEditConfigs: true,
									canApprove: true,
									canRecommend: true
								});
							}
						} else if(data.report_status == 3) {
							// Status: Approved
							// No one can edit anymore
							if(userProfile.pp_role_id <= 100) {
								this.setState({
									canPublish: true,
									canShowHide: true
								});
							}

						} else if(data.report_status == 4) {
							// Status: Published
							// Admin role can edit sizing form and configs
							if(userProfile.pp_role_id == 1) {
								this.setState({
									canEditSizingForm: true,
									canEditConfigs: true,
									canEditReportConfigs: true,
									canReject: true,
									showChart: true
								});
							}
						} else if(data.report_status == 5) {
							// Status: Rejected
							// Admin role can restore to configured status
							if(userProfile.pp_role_id == 1) {
								this.setState({
									canRestore: true,
									showChart: true
								});
							}
						}

						// convert units if needed
						if(data.units == "English") {
							data.displacement = this.convertKiloToLbs(data.displacement);
							data.loa = this.convertMetersToFeet(data.loa);
							data.lwl = this.convertMetersToFeet(data.lwl);
							data.boa = this.convertMetersToFeet(data.boa);
							data.bwl = this.convertMetersToFeet(data.bwl);
							data.draft_wo_appendages = this.convertMetersToFeet(data.draft_wo_appendages);
							data.waterline_beam_transom = this.convertMetersToFeet(data.waterline_beam_transom);
							data.gmt = this.convertMetersToFeet(data.gmt);
							data.gmt_est = this.convertMetersToFeet(data.gmt_est);
						}

						let original_values = data.original_values;
						if (original_values) {
							original_values.gmt = Math.round(data.gmt_est * 100) / 100;
							original_values.troll = Math.round(data.troll_est * 100) / 100;	
						}

						this.setState({
							sizingFormId: data.sizing_form_id,
							reportID: data.report_id,
							builderInfo: {
								selectedId: data.builder_id,
								selectedText: data.builder_name
							},
							modelInfo: {
								selectedId: data.model_id,
								selectedText: data.model_name
							},
							year: data.boat_year,
							bmyInfo: tempBMY,
							vesselInfo: {
								...this.state.vesselInfo,
								fullLoad: data.displacement,
								GMT: data.gmt,
								GMT_est: data.gmt_est,
								LOA: data.loa,
								LWL: data.lwl,
								BOA: data.boa,
								BWL: data.bwl,
								hullName: data.hull_name,
								application: data.boat_application,
								subApplication: data.boat_sub_application,
								vesselUse: data.vessel_use,
								hullType: data.hull_type,
								vesselInstallation: data.vessel_installation,
								appendages: data.draft_wo_appendages,
								waterlineTransom: data.waterline_beam_transom,
								deadriseBwl: data.deadrise_angle_bwl_max,
								deadriseTransom: data.deadrise_angle_hull_transom,
								naturalRollPeriod: data.troll,
								naturalRollPeriod_est: data.troll_est,
								operationHours: data.hours_of_operation,
								demoHullMaxBWL: data.demo_hull_max_bwl,
								demoHullSpacingBWL: data.demo_hull_spacing_bwl,
								notes: data.notes
							},
							configInfo: tempConfigs,
							customerInfo: tempCustomer,
							disableBMY: true,
							disableVessel: true,
							isNew: false,
							reportStatus: data.report_status,
							selectedSalesUser: data.sales_user_id,
							unit: data.units,
							loading: false,
							hasOverride: data.has_override,
							originalValues: data.original_values,
							newRequirements2023: newRequirements2023
						});

						// do we have a chart?
						if(data.calculations) {
							this.calculatePlotData(data.calculations, data.maxReduction);
						}

					} else {
						if(result.messages) {
							this.showMessage(result.messages.join("\n"));
						}
					}
				},
				(error) => {
					this.setState({
						error
					});
					this.showMessage('Something went wrong. Please try again later.');
				}
			);
			this.setState({
				sizingFormId: sizing_form_id
			});
			//this.getSalesUsers();
		} else {
			let userProfile = this.Auth.getProfile();
			// sales and admin roles can add up to 5 configurations
			if(userProfile.pp_role_id <= 100) {
				this.setState({
					maxConfigs: 5
				});
			}
			this.setState({
				customerInfo: this.Auth.getProfile(),
				canEditConfigs: true,
				loading: false
			});
		}
	}

	getSalesUsers() {
		this.Auth.fetch('/pp-users/by-role/100')
		.then(
			(result) => {
				console.log(result.data);
				if(result.success) {
					this.setState({
						salesUserList: result.users
					});

					// check if current user is in sales list and select them
					let userProfile = this.Auth.getProfile();
					let salesUserCount = result.users.length;
					for(let i=0; i<salesUserCount; i++) {
						if(userProfile.pp_user_id === result.users[i].pp_user_id) {
							this.setState({
								selectedSalesUser: userProfile.pp_user_id
							});
						}
					}
				}
			},
			(error) => {
				this.setState({
					error
				});
				this.showMessage('Something went wrong. Please try again later.');
			}
		);
	}

	changeSalesUser(e) {
		let target = e.target;
		let value = target.value;

		this.setState({
			selectedSalesUser: value
		});
	}

	setBMY(bmy) {
		this.setState({
			bmyInfo: bmy,
			vesselInfo: {
				...this.state.vesselInfo,
				fullLoad: bmy.displacement,
				GMT: bmy.gmt,
				GMT_est: bmy.gmt_est,
				LOA: bmy.loa,
				LWL: bmy.lwl,
				BOA: bmy.boa,
				BWL: bmy.bwl,
				appendages: bmy.draft_wo_appendages,
				waterlineTransom: bmy.waterline_beam_transom,
				deadriseBwl: bmy.deadrise_angle_bwl_max,
				deadriseTransom: bmy.deadrise_angle_hull_transom,
				naturalRollPeriod: bmy.troll,
				naturalRollPeriod_est: bmy.troll_est,
				operationHours: bmy.hours_of_operation,
				application: bmy.boat_application,
				subApplication: bmy.boat_sub_application,
				vesselUse: bmy.vessel_use,
				hullType: bmy.hull_type,
				vesselInstallation: bmy.vessel_installation,
				demoHullMaxBWL: bmy.demo_hull_max_bwl,
				demoHullSpacingBWL: bmy.demo_hull_spacing_bwl,
			}
		});
	}

	changeBuilder(builderInfo) {
		this.setState({
			builderInfo
		});
	}

	changeModel(modelInfo) {
		this.setState({
			modelInfo
		});
	}

	changeYear(year) {
		var digit = /^[0-9]+$/;
		if(year.length === 4 && digit.test(year) && (this.state.isNew || this.state.isEditing)) {
			// we have a valid year, let's check for a valid model
			let formData = new FormData();
			let { modelInfo } = this.state;

			if(modelInfo.selectedId !== null) {
				formData.append("model_id", modelInfo.selectedId);
				formData.append("year", year);

				this.Auth.post('/check-bmy', formData)
				.then(
					(result) => {
						if(result.success) {

							if (this.state.isEditing && !result.bmy.hasOwnProperty('bmy_id')) {
								this.showMessage('Please enter boat details below to create a new boat.', 'Boat not found');
								let bmyInfo = this.state.bmyInfo;
								bmyInfo.bmy_id = null;
								this.setState({
									bmyInfo: bmyInfo
								})
							} else {
								let userProfile = this.Auth.getProfile();
								// sales and admin roles get pre-populated fields
								if(userProfile.pp_role_id <= 100) {
									this.setBMY(result.bmy);
								} else {
									this.setState({
										bmyInfo: result.bmy
									});
								}
							}
						} else {
							if(result.messages) {
								this.showMessage(result.messages.join("\n"));
							}
						}
					},
					(error) => {
						this.setState({
							error
						});
						this.showMessage('Something went wrong. Please try again later.');
					}
				);
			}
		}

		this.setState({
			year
		});
	}

	vesselInfoChange(propName, propValue) {
		var map = {
			'application': 'boat_application',
			'vesselUse': 'vessel_use',
			'subApplication': 'boat_sub_application',
			'hullType': 'hull_type',
			'vesselInstallation': 'vessel_installation',
			'fullLoad': 'displacement',
			'operationHours' : 'hours_of_operation',
			'LOA': 'loa',
			'LWL': 'lwl',
			'BOA': 'boa',
			'BWL': 'bwl',
			'appendages': 'draft_wo_appendages',
			'waterlineTransom': 'waterline_beam_transom',
			'deadriseBwl': 'deadrise_angle_bwl_max',
			'deadriseTransom': 'deadrise_angle_hull_transom',
			'GMT': 'gmt',
			'naturalRollPeriod': 'troll',
			'demoHullMaxBWL': 'demo_hull_max_bwl',
			'demoHullSpacingBWL': 'demo_hull_spacing_bwl',
		};

		console.log(propName);

		if (propValue === '' && this.state.originalValues && this.state.originalValues[map[propName]]) {
			propValue = this.state.originalValues[map[propName]];
		}

		if(propName === "application") {
			this.setState({
				vesselInfo: {
					...this.state.vesselInfo,
					[propName]: propValue,
					"subApplication": ""
				}
			});
		} else {
			this.setState({
				vesselInfo: {
					...this.state.vesselInfo,
					[propName]: propValue
				}
			});
		}

		// update any necessary BMY fields
		if(this.state.bmyInfo.hasOwnProperty(propName.toLowerCase())) {
			this.setState({
				bmyInfo: {
					...this.state.bmyInfo,
					[propName.toLowerCase()]: propValue
				}
			})
		}
	}

	configInfoChange(configIndex, skIndex, data) {
		if(data == null) return;

		console.log(tempConfigData, skIndex, configIndex);

		let tempConfigData = this.state.configInfo;
		let tempSkData = tempConfigData[configIndex].seakeeperData[skIndex];

		// special case for first selection of model
		if(tempSkData.seakeeperModel == "" && data.key == "seakeeperModel" && data.value != "") {
			tempSkData = {
				numGyros: "1",
				seakeeperModel: data.value
			};
		} else {
			tempSkData = {
				...tempSkData,
				[data.key]: data.value
			};
		}

		tempConfigData[configIndex].seakeeperData[skIndex] = tempSkData;

		this.setState({
			tempConfigData
		});
	}

	addConfigSeakeeper(configIndex) {
		let tempConfigData = this.state.configInfo;
		let tempSkData = tempConfigData[configIndex].seakeeperData;

		// limit configurations to 3 seakeepers
		if(tempSkData.length >= this.state.maxSeakeepers) {
			tempConfigData[configIndex].disableAddSeakeeper = true;
			this.setState({
				configInfo: tempConfigData
			});
			return;
		}

		tempSkData.push({
			seakeeperModel: "",
			numGyros: ""
		});

		tempConfigData[configIndex].seakeeperData = tempSkData;
		if(tempSkData.length === this.state.maxSeakeepers) {
			tempConfigData[configIndex].disableAddSeakeeper = true;
		}
		this.setState({
			configInfo: tempConfigData
		});
	}

	addConfiguration() {
		let configCount = this.state.configInfo.length;
		let tempConfigData = this.state.configInfo;

		if(configCount >= this.state.maxConfigs) {
			this.setState({
				disableAddConfiguration: true
			});
			return;
		}

		tempConfigData.push({
			title: "Configuration " + (configCount + 1),
			index: this.state.configInfo.length,
			seakeeperData: [
				{
					seakeeperModel: "",
					numGyros: ""
				}
			]
		});

		if(tempConfigData.length === this.state.maxConfigs) {
			this.setState({
				disableAddConfiguration: true
			});
		}

		this.setState({
			configInfo: tempConfigData
		});
	}

	deleteConfigSeakeeper(configIndex, skIndex) {
		console.log("delete " + configIndex + " : " + skIndex);
		let tempConfigData = this.state.configInfo;

		// check valid config and sk index
		if(configIndex >= 0 && tempConfigData.length >= configIndex) {
			if(skIndex >= 0 && tempConfigData[configIndex].seakeeperData.length >= skIndex) {
				tempConfigData[configIndex].seakeeperData.splice(skIndex, 1);

				if(tempConfigData[configIndex].seakeeperData.length >= this.state.maxSeakeepers) {
					tempConfigData[configIndex].disableAddSeakeeper = true;
				} else {
					tempConfigData[configIndex].disableAddSeakeeper = false;
				}

				this.setState({
					configInfo: tempConfigData
				});
			}
		}
	}

	deleteConfiguration(configIndex) {
		let tempConfigData = this.state.configInfo;

		console.log(tempConfigData);
		console.log('delete', configIndex);

		// check that index is in range
		if(configIndex >= 0 && tempConfigData.length >= configIndex) {
			tempConfigData.splice(configIndex, 1);
			this.setState({
				configInfo: tempConfigData
			});
		}

		if(tempConfigData.length < this.state.maxConfigs) {
			this.setState({
				disableAddConfiguration: false
			});
		}
	}

	editClick() {
		if(this.state.canEditSizingForm) {
			this.setState({
				disableBMY: false,
				disableVessel: false,
				disableConfig: false,
				isEditing: true
			});
		} else {
			this.showMessage("You do not have permission to edit this sizing form.");
		}
	}

	copyClick() {
		this.showMessage('', 'Copy this sizing form?', <div><button className="pp-button" onClick={this.copySizingForm}>Copy</button><button className="pp-text-button" onClick={this.hideMessage}>Cancel</button></div>);	
	}

	copySizingForm() {
		this.hideMessage();
		this.setState({
			copying: true
		});
		this.Auth.post('/prediction/sizing-form/' + this.state.sizingFormId + '/duplicate')
		.then(
			(result) => {
				if (result.success === true) {
					this.showMessage(<a href={result.new_sizing_form_id}>View new sizing form.</a>, 'Sizing form copied sucessfully!');
					this.setState({
						copying: false
					});
				}
			}
		);
	}

	cancelEdit(e) {
		e.preventDefault();
		this.setState({
			disableBMY: true,
			disableVessel: true,
			disableConfig: true,
			isEditing: false,
			isEditingConfigs: false,
			isEditingReportConfigs: false
		});
	}

	validateSizingForm() {
		let validCount = this.validationObject.length;
		let errors = [];
		let stateErrors = {};
		let hasErrors = false;

		for(let i=0; i<validCount; i++) {
			if(this.validationObject[i].required) {
				if(this.validationObject[i].parent) {
					if( !this.state[this.validationObject[i].parent][this.validationObject[i].fieldName]) {
						let message = this.validationObject[i].errorMessage;
						errors.push(<p>{message}</p>);
						stateErrors[this.validationObject[i].fieldName] = true;
						hasErrors = true;
					}
				} else {
					if( !this.state[this.validationObject[i].fieldName]) {
						let message = this.validationObject[i].errorMessage;
						errors.push(<p>{message}</p>);
						stateErrors[this.validationObject[i].fieldName] = true;
						hasErrors = true;
					}
				}
			}
		}

		if(hasErrors) {
			this.showMessage(errors, "Please complete these required fields");
			this.setState({
				errors: stateErrors
			});
		}

		return !hasErrors;
	}

	createBMY(callback) {
		var digit = /^[0-9]+$/;
		if(this.state.year.length === 4 && digit.test(this.state.year) && (this.state.isNew || this.state.isEditing)) {
			// we have a valid year, lets try to create bmy
			let formData = new FormData();
			let { builderInfo, modelInfo } = this.state;
			if(builderInfo.selectedId !== null) {
				formData.append("builder_id", builderInfo.selectedId);
			}
			formData.append("builder_name", builderInfo.selectedText);

			if(modelInfo.selectedId !== null) {
					formData.append("model_id", modelInfo.selectedId);
			}
			formData.append("model_name", modelInfo.selectedText);
			formData.append("year", this.state.year);

			this.Auth.post('/create-bmy', formData)
			.then(
				(result) => {
					console.log(result);
					if(result.success === true) {
						this.setState({
							bmyInfo: {
								...this.state.bmyInfo,
								bmy_id: result.bmy.bmy_id
							}
						}, callback);
					} else {
						if(result.messages) {
							this.showMessage(result.messages.join("\n"));
						}
					}
				},
				(error) => {
					this.setState({
						error
					});
				}
			);
		}
	}

	submitSizingForm(e) {
		let formData = new FormData();
		var target = e.target;
		const { sizingFormId, vesselInfo } = this.state;

		// check if we need to create new BMY
		if( !this.state.bmyInfo.bmy_id) {
			let self = this;
			let event = e;
			this.createBMY(function() {
				self.submitSizingForm(event);
			});
			return;
		}

		if( !this.validateSizingForm()) {
			return;
		}

		this.loadingButton(target);




		let tempVesselInfo = vesselInfo;
		// check units, convert to metric for submission
		if(this.state.unit == "English") {
			// convert all numbers from English to Metric
			tempVesselInfo = {
				...vesselInfo,
				fullLoad: this.convertLbsToKilo(vesselInfo.fullLoad),
				BOA: this.convertFeetToMeters(vesselInfo.BOA),
				BWL: this.convertFeetToMeters(vesselInfo.BWL),
				LOA: this.convertFeetToMeters(vesselInfo.LOA),
				LWL: this.convertFeetToMeters(vesselInfo.LWL),
				appendages: this.convertFeetToMeters(vesselInfo.appendages),
				waterlineTransom: this.convertFeetToMeters(vesselInfo.waterlineTransom),
				GMT: this.convertFeetToMeters(vesselInfo.GMT),
				demoHullMaxBWL: this.convertFeetToMeters(vesselInfo.demoHullMaxBWL),
				demoHullSpacingBWL: this.convertFeetToMeters(vesselInfo.demoHullSpacingBWL),
			}
		}
		tempVesselInfo.units = this.state.unit;

		formData.append("bmy_info", JSON.stringify(this.state.bmyInfo));
		formData.append("vessel_info", JSON.stringify(tempVesselInfo));
		formData.append("config_info", JSON.stringify(this.state.configInfo));
		formData.append("sales_user", this.state.selectedSalesUser);

		if(sizingFormId === null) {
			// we are creating a new sizing form
			this.Auth.post('/prediction/sizing-form', formData)
			.then(
				(result) => {
					console.log(result);
					if(result.success) {
						this.props.history.push('/sizing-form/created');
					} else {
						if(result.messages) {
							this.showMessage(result.messages.join("\n"));
						}
					}
					this.removeLoadingButton(target);
				},
				(error) => {
					this.setState({
						error
					});
					this.removeLoadingButton(target);
					this.showMessage('Something went wrong. Please try again later.');
				}
			);
		} else {
			this.showMessage("This appears to be an existing sizing form, can not create new sizing form.");
			this.removeLoadingButton(target);
		}

	}

	updateSizingForm(e) {
		let formData = new FormData();
		var target = e.target;
		const { sizingFormId, vesselInfo } = this.state;

		// check if we need to create new BMY
		if( !this.state.bmyInfo.bmy_id) {
			let self = this;
			let event = e;
			this.createBMY(function() {
				self.updateSizingForm(event);
			});
			return;
		}

		if( !this.validateSizingForm()) {
			return;
		}

		this.loadingButton(target);

		let tempVesselInfo = vesselInfo;
		// check units, convert to metric for submission
		if(this.state.unit == "English") {
			// convert all numbers from English to Metric
			tempVesselInfo = {
				...vesselInfo,
				fullLoad: this.convertLbsToKilo(vesselInfo.fullLoad),
				BOA: this.convertFeetToMeters(vesselInfo.BOA),
				BWL: this.convertFeetToMeters(vesselInfo.BWL),
				LOA: this.convertFeetToMeters(vesselInfo.LOA),
				LWL: this.convertFeetToMeters(vesselInfo.LWL),
				appendages: this.convertFeetToMeters(vesselInfo.appendages),
				waterlineTransom: this.convertFeetToMeters(vesselInfo.waterlineTransom),
				GMT: this.convertFeetToMeters(vesselInfo.GMT),
				GMT_est: this.convertFeetToMeters(vesselInfo.GMT_est),
				demoHullMaxBWL: this.convertFeetToMeters(vesselInfo.demoHullMaxBWL),
				demoHullSpacingBWL: this.convertFeetToMeters(vesselInfo.demoHullSpacingBWL)
			}
		}
		tempVesselInfo.units = this.state.unit;

		formData.append("bmy_info", JSON.stringify(this.state.bmyInfo));
		formData.append("vessel_info", JSON.stringify(tempVesselInfo));
		formData.append("sales_user", this.state.selectedSalesUser);
		//formData.append("config_info", JSON.stringify(this.state.configInfo));

		if(sizingFormId === null) {
			this.showMessage("Unknown sizing form ID, unable to update.");
			this.removeLoadingButton(target);
		} else {
			console.log('saving...');
			console.log(this.state.bmyInfo);
			// we are updating an existing sizing form
			this.Auth.post('/prediction/sizing-form/' + sizingFormId, formData)
			.then(
				(result) => {
					console.log(result);
					if(result.success) {
						this.showMessage('', 'The sizing form has been updated');
						this.setState({
							disableBMY: true,
							disableVessel: true,
							disableConfig: true,
							isEditing: false,
							isEditingConfigs: false
						});
					} else {
						if(result.messages) {
							this.showMessage(result.messages.join("\n"));
						}
					}
					this.removeLoadingButton(target);
				},
				(error) => {
					this.setState({
						error
					});
					this.removeLoadingButton(target);
					this.showMessage('Something went wrong. Please try again later.');
				}
			);
		}
	}

	updateConfigurations(e) {
		let formData = new FormData();
		var target = e.target;
		const { sizingFormId } = this.state;

		this.loadingButton(target);

		formData.append("config_info", JSON.stringify(this.state.configInfo));

		if(sizingFormId === null) {
			this.showMessage("Unknown sizing form ID, unable to update.");
			this.removeLoadingButton(target);
		} else {
			// we are updating an existing sizing form
			this.Auth.post('/prediction/sizing-form/' + sizingFormId + '/configurations', formData)
			.then(
				(result) => {
					console.log(result);
					if(result.success) {
						this.showMessage('', 'The configurations have been updated');
						// we need to refresh for canApprove users to get a new graph
						if(this.state.displayChart) {
							this.showMessage('Please reload the page to continue', "The configurations have been updated", <button className="pp-button" onClick={this.reloadPage}>Reload</button>);
						}


						// Configuration Data
						let data = result.data;
						let configurations = data.configurations;
						let tempConfigs = [];
						if(configurations) {
							for(let i=0; i<configurations.length; i++) {
								let tempConfig = {
									title: "Configuration " + (i+1),
									seakeeperData: [],
									configID: configurations[i][0].config_id,
									showConfig: configurations[i][0].show_dealer
								};

								if(configurations[i][0].recommended === "1" || configurations[i][0].recommended === 1) {
									this.setState({
										recommendedConfiguration: configurations[i][0].config_id
									});
								}

								for(let j=0; j<configurations[i].length; j++) {
									tempConfig.seakeeperData.push({
										seakeeperModel: configurations[i][j].sk_model_id,
										numGyros: configurations[i][j].sk_model_count
									});
								}
								if(configurations[i].length >= this.state.maxSeakeepers) {
										tempConfig.disableAddSeakeeper = true;
								}
								tempConfigs.push(tempConfig);
							}
						}
						if(tempConfigs.length >= this.state.maxConfigs) {
							this.setState({
								disableAddConfiguration: true
							});
						}

						this.setState({
							configInfo: tempConfigs,
							recommendedConfiguration: null,
							isEditingConfigs: false
						});
					} else {
						if(result.messages) {
							this.showMessage(result.messages.join("\n"));
						}
					}
					this.removeLoadingButton(target);
				},
				(error) => {
					this.setState({
						error
					});
					this.removeLoadingButton(target);
					this.showMessage('Something went wrong. Please try again later.');
				}
			);
		}
	}

	unitChange(unit) {

		if(this.state.unit === unit) {
			return;
		}
		let { vesselInfo } = this.state;
		let tempVesselInfo = {};
		if(unit == "Metric") {
			// convert all numbers from English to Metric
			tempVesselInfo = {
				...vesselInfo,
				fullLoad: this.convertLbsToKilo(vesselInfo.fullLoad),
				BOA: this.convertFeetToMeters(vesselInfo.BOA),
				BWL: this.convertFeetToMeters(vesselInfo.BWL),
				LOA: this.convertFeetToMeters(vesselInfo.LOA),
				LWL: this.convertFeetToMeters(vesselInfo.LWL),
				appendages: this.convertFeetToMeters(vesselInfo.appendages),
				waterlineTransom: this.convertFeetToMeters(vesselInfo.waterlineTransom),
				GMT: this.convertFeetToMeters(vesselInfo.GMT),
				GMT_est: this.convertFeetToMeters(vesselInfo.GMT_est),
				demoHullMaxBWL: this.convertFeetToMeters(vesselInfo.demoHullMaxBWL),
				demoHullSpacingBWL: this.convertFeetToMeters(vesselInfo.demoHullSpacingBWL),
			}
		} else {
			// convert all numbers from Metric to English
			tempVesselInfo = {
				...vesselInfo,
				fullLoad: this.convertKiloToLbs(vesselInfo.fullLoad),
				BOA: this.convertMetersToFeet(vesselInfo.BOA),
				BWL: this.convertMetersToFeet(vesselInfo.BWL),
				LOA: this.convertMetersToFeet(vesselInfo.LOA),
				LWL: this.convertMetersToFeet(vesselInfo.LWL),
				appendages: this.convertMetersToFeet(vesselInfo.appendages),
				waterlineTransom: this.convertMetersToFeet(vesselInfo.waterlineTransom),
				GMT: this.convertMetersToFeet(vesselInfo.GMT),
				GMT_est: this.convertMetersToFeet(vesselInfo.GMT_est),
				demoHullMaxBWL: this.convertMetersToFeet(vesselInfo.demoHullMaxBWL),
				demoHullSpacingBWL: this.convertMetersToFeet(vesselInfo.demoHullSpacingBWL),
			}
		}

		this.setState({
			unit: unit,
			vesselInfo: tempVesselInfo
		});
	}

	convertFeetToMeters(feet) {
		let meters = (feet / 3.2808);
		//meters = Math.floor(meters * 100000) / 100000;
		return meters;
	}

	convertMetersToFeet(meters) {
		let feet = (meters * 3.2808);
		//feet = Math.round(feet * 1000) / 1000;
		return feet;
	}

	convertKiloToLbs(kilo) {
		let lbs = (kilo * 2.2046);
		//lbs = Math.round(lbs * 1000) / 1000;
		return lbs;
	}

	convertLbsToKilo(lbs) {
		let kilo = (lbs / 2.2046);
		//kilo = Math.round(kilo * 1000) / 1000;
		return kilo;
	}

	submitForApproval(e) {
		const { reportStatus, sizingFormId } = this.state;
		var target = e.target;
		// make sure they are allowed to do this action
		let userProfile = this.Auth.getProfile();
		if(reportStatus == 1) {
			// Status: Created
			// Sales and Admin roles can submit for approval

			if(userProfile.pp_role_id <= 100) {
				let formData = new FormData();
				formData.append("sizing_form_id", sizingFormId);
				this.loadingButton(target);
				this.Auth.post('/prediction/sizing-form/' + sizingFormId + '/submit-for-approval', formData)
				.then(
					(result) => {
						console.log(result);
						if(result.success) {
							this.props.history.push('/sizing-form/configured');
						} else {
							if(result.messages) {
								this.showMessage(result.messages.join("\n"));
							}
						}
						this.removeLoadingButton(target);
					},
					(error) => {
						this.setState({
							error
						});
						this.removeLoadingButton(target);
						this.showMessage('Something went wrong. Please try again later.');
					}
				);
			} else {
				this.showMessage("You do not have permissions to submit for approval.");
			}
		} else {
			this.showMessage("This sizing form is not able to be submitted for approval.");
		}
	}

	approveSizingForm(e) {
		const { reportStatus, sizingFormId, recommendedConfiguration } = this.state;
		var target = e.target;
		// make sure they are allowed to do this action
		let userProfile = this.Auth.getProfile();
		if(reportStatus == 2) {
			// Status: Configured
			// Admin role can approve
			if(userProfile.pp_role_id == 1) {

				if(recommendedConfiguration !== null) {
					let formData = new FormData();
					formData.append("sizing_form_id", sizingFormId);
					formData.append("recommended_config", recommendedConfiguration);
					this.loadingButton(target);
					this.Auth.post('/prediction/sizing-form/' + sizingFormId + '/approve', formData)
					.then(
						(result) => {
							console.log(result);
							if(result.success) {
								this.props.history.push('/sizing-form/approved');
							} else {
								if(result.messages) {
									this.showMessage(result.messages.join("\n"));
								}
							}
							this.removeLoadingButton(target);
						},
						(error) => {
							this.setState({
								error
							});
							this.removeLoadingButton(target);
							this.showMessage('Something went wrong. Please try again later.');
						}
					);
				} else {
					this.showMessage("Please recommend a configuration before approving.", "Recommend a Configuration");
				}
			} else {
				this.showMessage("You do not have permissions approve the sizing form.");
			}
		} else {
			this.showMessage("This sizing form is not able to be approved until submitted for approval.");
		}
	}

	updateRecommendation(e) {
		const { reportStatus, sizingFormId, recommendedConfiguration } = this.state;
		var target = e.target;
		// make sure they are allowed to do this action
		let userProfile = this.Auth.getProfile();
		if(reportStatus >= 2) {
			// Status: Configured or greater
			// Admin role can update recommendation
			if(userProfile.pp_role_id == 1) {

				if(recommendedConfiguration !== null) {
					let formData = new FormData();
					formData.append("sizing_form_id", sizingFormId);
					formData.append("recommended_config", recommendedConfiguration);

					// build out the show/hide for each configuration
					let configShowHide = [];
					let { configInfo } = this.state;
					let configCount = configInfo.length;
					for(let i=0; i < configCount; i++) {
						configShowHide.push({
							configID: configInfo[i].configID,
							show: configInfo[i].showConfig
						});
					}
					formData.append("config_show", JSON.stringify(configShowHide));

					this.loadingButton(target);
					this.Auth.post('/prediction/sizing-form/' + sizingFormId + '/recommend', formData)
					.then(
						(result) => {
							console.log(result);
							if(result.success) {
								this.showMessage('', 'The recommended configuration has been updated');
								this.setState({
									disableBMY: true,
									disableVessel: true,
									disableConfig: true,
									isEditing: false,
									isEditingConfigs: false,
									isEditingReportConfigs: false
								});
							} else {
								if(result.messages) {
									this.showMessage(result.messages.join("\n"));
								}
							}
							this.removeLoadingButton(target);
						},
						(error) => {
							this.setState({
								error
							});
							this.removeLoadingButton(target);
							this.showMessage('Something went wrong. Please try again later.');
						}
					);
				} else {
					this.showMessage("Please recommend a configuration before updating.", "Recommend a Configuration");
				}
			} else {
				this.showMessage("You do not have permissions to update the recommendation.");
			}
		} else {
			this.showMessage("This recommendation is not able to be updated at this time.");
		}
	}

	rejectSizingForm(e) {
		const { reportStatus, sizingFormId } = this.state;
		var target = e.target;
		// make sure they are allowed to do this action
		let userProfile = this.Auth.getProfile();
		// we used to only allow rejection before approval, commenting out before removing permanently
		//if(reportStatus < 3) {
			// Status: Created or Configured
			// Admin role can reject
			if(userProfile.pp_role_id == 1) {
				let formData = new FormData();
				formData.append("sizing_form_id", sizingFormId);
				this.loadingButton(target);
				this.Auth.post('/prediction/sizing-form/' + sizingFormId + '/reject', formData)
				.then(
					(result) => {
						console.log(result);
						if(result.success) {
							var button = <button className="pp-button" onClick={this.hideMessageRedirect}>Close</button>;
							this.showMessage('', 'The sizing form has been rejected', button);
						} else {
							if(result.messages) {
								this.showMessage(result.messages.join("\n"));
							}
						}
						this.removeLoadingButton(target);
					},
					(error) => {
						this.setState({
							error
						});
						this.removeLoadingButton(target);
						this.showMessage('Something went wrong. Please try again later.');
					}
				);
			} else {
				this.showMessage("You do not have permissions reject this sizing form.");
			}
		// } else {
		// 	this.showMessage("This sizing form is not able to be rejected if it was already approved.");
		// }
	}

	publishSizingForm(e) {
		const { reportStatus, sizingFormId } = this.state;
		var target = e.target;
		// make sure they are allowed to do this action
		let userProfile = this.Auth.getProfile();
		if(reportStatus == 3) {
			// Status: Approved
			// Admin or Sales role can publish
			if(userProfile.pp_role_id <= 100) {
				let formData = new FormData();
				formData.append("sizing_form_id", sizingFormId);

				// build out the show/hide for each configuration
				let configShowHide = [];
				let { configInfo } = this.state;
				let configCount = configInfo.length;
				for(let i=0; i < configCount; i++) {
					configShowHide.push({
						configID: configInfo[i].configID,
						show: configInfo[i].showConfig
					});
				}
				formData.append("config_show", JSON.stringify(configShowHide));

				this.loadingButton(target);
				this.Auth.post('/prediction/sizing-form/' + sizingFormId + '/publish', formData)
				.then(
					(result) => {
						console.log(result);
						if(result.success) {
							this.props.history.push('/sizing-form/published/' + this.state.reportID);
						} else {
							if(result.messages) {
								this.showMessage(result.messages.join("\n"));
							}
						}
						this.removeLoadingButton(target);
					},
					(error) => {
						this.setState({
							error
						});
						this.removeLoadingButton(target);
						this.showMessage('Something went wrong. Please try again later.');
					}
				);
			} else {
				this.showMessage("You do not have permissions publish this sizing form.");
			}
		} else {
			this.showMessage("This sizing form is not able to be published until it is approved by an admin.");
		}
	}

	restoreSizingForm(e) {
		const { reportStatus, sizingFormId } = this.state;
		var target = e.target;
		// make sure they are allowed to do this action
		let userProfile = this.Auth.getProfile();
		if(reportStatus == 5) {
			// Status: Rejected
			// Admin role can restore
			if(userProfile.pp_role_id <= 100) {
				let formData = new FormData();
				formData.append("sizing_form_id", sizingFormId);

				this.loadingButton(target);
				this.Auth.post('/prediction/sizing-form/' + sizingFormId + '/restore', formData)
				.then(
					(result) => {
						console.log(result);
						if(result.success) {
							var button = <button className="pp-button" onClick={this.hideMessageRedirect}>Close</button>;
							this.showMessage('', 'The sizing form has been restored to the Configured state.', button);
						} else {
							if(result.messages) {
								this.showMessage(result.messages.join("\n"));
							}
						}
						this.removeLoadingButton(target);
					},
					(error) => {
						this.setState({
							error
						});
						this.removeLoadingButton(target);
						this.showMessage('Something went wrong. Please try again later.');
					}
				);
			} else {
				this.showMessage("You do not have permissions restore this sizing form.");
			}
		} else {
			this.showMessage("This sizing form is not currently Rejected, so it can't be restored.");
		}
	}

	loadingButton(target) {
		if(target) {
			target.disabled = true;
			target.classList.add('pp-loading');
		}
	}

	removeLoadingButton(target) {
		if(target) {
			target.disabled = false;
			target.classList.remove('pp-loading');
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showMessage(body, title, actionButtons) {
		var messageTitle = title || ' ',
			messageActionButtons = actionButtons || <button className="pp-button" onClick={this.hideMessage}>Close</button>;

		this.setState({
			message: {
				body: body,
				title: messageTitle,
				actionButtons: messageActionButtons
			}
		});
	}

	hideMessage() {
		this.setState({
			message: false
		});
	}

	hideMessageRedirect() {
		this.setState({
			message: false
		});
		this.props.history.push('/dashboard');
	}

	confirmReject() {
		var messageButtons = <span className="pp-button-wrapper">
			<button type="button" className="pp-button" onClick={this.rejectSizingForm}>Reject</button>
			<p className="pp-instruction">or</p>
			<button type="button" className="pp-cancel" onClick={this.hideMessage}>Cancel</button>
		</span>;

		this.showMessage('This action cannot be undone.', 'Reject this Sizing Form?', messageButtons);
	}

	updateRecommendConfig(configID) {
		this.setState({
			recommendedConfiguration: configID
		});
	}

	editConfigurationsClick() {
		if(this.state.canEditConfigs) {
			this.setState({
				isEditingConfigs: true
			});
		} else {
			this.showMessage("You do not have permission to edit the configurations.");
		}
	}

	editReportConfigsClick() {
		if(this.state.canEditReportConfigs) {
			this.setState({
				isEditingReportConfigs: true
			});
		} else {
			this.showMessage("You do not have permission to edit the configurations.");
		}
	}

	configChangeShowHide(configIndex, value) {
		let tempConfigData = this.state.configInfo;

		// make sure index is in range
		if(configIndex >= 0 && configIndex < tempConfigData.length) {
			// get config ID to update the DB and change the show status
			let configID = tempConfigData[configIndex].configID;
			if(value == "Include") {
				tempConfigData[configIndex].showConfig = "1";
			} else {
				tempConfigData[configIndex].showConfig = "0";
			}
			this.setState({
				configInfo: tempConfigData
			});
		}
	}

	calculatePlotData(configurations, maxReduction = 80) {
		var configCount = configurations.length;
		var slotCount = 0;
		var pointData = [];
		let userProfile = this.Auth.getProfile();
		let hidden = 0;

		let maxAngle = 25;
		
		// Catamarans only 
		if (this.isCatamaran()) {
			maxAngle = 15;
			this.chartData.labels.splice(-10, 10);

		// all other boat types
		} else {
			if(this.state.vesselInfo.vesselUse === "Coastal") {
				maxAngle = 20;
				this.chartData.labels.splice(-5, 5);
			}
		}

		for(let i=0; i<configCount; i++) {
			// don't calculate for dealer if not show

			if(configurations[i].showConfig === "0" || configurations[i].showConfig === 0) {
				hidden++;
				continue;
			}

			pointData = [];
			configurations[i].PlotData = [];
			configurations[i].reductionData = [];
			var point = 0;
			for(let k=0; k<=25; k+=1) {
				if (k != 0) {
					k = Math.round(k * 100) / 100;
				} else {
					k = 0;
				}
				
				point = 100 * configurations[i].TotalDeltaPhi / k;
				if(point < maxReduction) {
					configurations[i].PlotData.push({
						degree: k,
						reduction: Math.round(point * 10000) / 10000
					});
					configurations[i].reductionData.push(
						Math.round(point * 10000) / 10000
					);
					pointData.push(Math.round(point * 10000) / 10000);
				} else {
					configurations[i].PlotData.push({
						degree: k,
						reduction: maxReduction
					});
					configurations[i].reductionData.push(
						maxReduction
					);
					pointData.push(maxReduction);
				}
			}
			this.chartData.datasets[i-hidden].data = pointData;
		}

		this.chartData.datasets.splice(configurations.length);
		this.chartData.datasets.push(
			{
				label: "",
				fillColor: "transparent",
				strokeColor: "transparent",
				pointHighlightFill: "transparent",
				data: [90,0]
			}
		
		)
		console.log(this.chartData, 'chartdata');
		this.setState({
			chartData: this.chartData,
			displayChart: true,
			configurations
		});
	}

	isCatamaran() {
		return (this.state.vesselInfo.subApplication == 10 || this.state.vesselInfo.subApplication == 34 || this.state.vesselInfo.subApplication == 35);
	}

	render() {
		const { bmyInfo,
				vesselInfo,
				builderInfo,
				modelInfo,
				year,
				configInfo,
				customerInfo,
			 	disableBMY,
				disableVessel,
				disableConfig,
			 	canEditSizingForm,
				unit,
			 	message,
				popupCallback,
				salesUserList,
				copying } = this.state;

		let editButton = "",
			unitClass = "pp-unit-" + unit,
			copy_button_class = (copying === true) ? 'pp-button pp-loading' : 'pp-button';

		let chartData = this.state.chartData;

		if(this.state.reportStatus == 4 && this.state.reportID) {
			if(this.state.canEditSizingForm) {
				editButton = (
					<div className="pp-edit-buttons">
						<button className={copy_button_class} onClick={this.copyClick}>Copy Sizing Form</button>
						<button className="pp-button" onClick={this.editClick}>Edit Sizing Form</button>
						<a className="pp-button" href={"/report/" + this.state.reportID}>View Report</a>
					</div>
				);
			} else {
				editButton = (
					<div className="pp-edit-buttons">
						<a className="pp-button" href={"/report/" + this.state.reportID}>View Report</a>
					</div>
				);
			}
		} else if(this.state.canEditSizingForm) {
			editButton = (
				<div className="pp-edit-buttons">
					<button className={copy_button_class} onClick={this.copyClick}>Copy Sizing Form</button>
					<button className="pp-button" onClick={this.editClick}>Edit Sizing Form</button>
				</div>
			);
		}


		let updateButtons = "";
		if(this.state.isNew) {
			updateButtons = (
				<div className="pp-action-buttons">
					<button type="submit" id="bmy-submit" className="pp-button" onClick={this.submitSizingForm}>Submit</button>
				</div>
			)
		} else if(this.state.isEditing) {
			updateButtons = (
				<div className="pp-action-buttons">
					<button type="submit" id="bmy-submit" className="pp-button" onClick={this.updateSizingForm}>Update Sizing Form</button>
					<p className="pp-instruction">or</p>
					<a className="pp-cancel" onClick={this.cancelEdit}>Cancel</a>
				</div>
			)
		} else if(this.state.isEditingConfigs) {
			updateButtons = (
				<div className="pp-action-buttons">
					<button type="submit" id="bmy-submit" className="pp-button" onClick={this.updateConfigurations}>Update Configurations</button>
					<p className="pp-instruction">or</p>
					<a className="pp-cancel" onClick={this.cancelEdit}>Cancel</a>
				</div>
			)
		} else if(this.state.isEditingReportConfigs) {
			updateButtons = (
				<div className="pp-action-buttons">
					<button type="submit" id="bmy-submit" className="pp-button" onClick={this.updateRecommendation}>Update Recommendations</button>
					<p className="pp-instruction">or</p>
					<a className="pp-cancel" onClick={this.cancelEdit}>Cancel</a>
				</div>
			)
		} else if(this.state.canEditConfigs) {
			updateButtons = (
				<div className="pp-action-buttons">
					<button type="submit" id="bmy-submit" className="pp-button" onClick={this.editConfigurationsClick}>Edit Configurations</button>
				</div>
			);

			if(this.state.canEditReportConfigs) {
				updateButtons = (
					<div className="pp-action-buttons">
						<button type="submit" id="bmy-submit" className="pp-button" onClick={this.editConfigurationsClick}>Edit Configurations</button>
						<button type="submit" id="bmy-submit" className="pp-button" onClick={this.editReportConfigsClick}>Edit Recommendation</button>
					</div>
				);
			}
		}

		let actionButtons = "";
		if(!this.state.isEditing && !this.state.isEditingConfigs) {
			if(this.state.canSubmitForApproval) {
				actionButtons = (
					<div className="pp-action-buttons">
						<button type="submit" id="bmy-submit" className="pp-button" onClick={this.submitForApproval}>Submit for Approval</button>
					</div>
				);
			}
			if(this.state.canApprove) {
				actionButtons = (
					<div className="pp-action-buttons">
						<button type="submit" id="bmy-submit" className="pp-button" onClick={this.approveSizingForm}>Approve</button>
						<p className="pp-instruction">or</p>
						<button type="submit" id="bmy-submit" className="pp-cancel" onClick={this.confirmReject}>Reject Sizing Form</button>
					</div>
				);
			}
			if(this.state.canReject) {
				actionButtons = (
					<div className="pp-action-buttons">
						<button type="submit" id="bmy-submit" className="pp-button" onClick={this.confirmReject}>Delete Sizing Form</button>
					</div>
				);
			}
			if(this.state.canPublish) {
				actionButtons = (
					<div className="pp-action-buttons">
						<button type="submit" id="bmy-submit" className="pp-button" onClick={this.publishSizingForm}>Publish</button>
					</div>
				);
			}
			if(this.state.canRestore) {
				actionButtons = (
					<div className="pp-action-buttons">
						<button type="submit" id="bmy-submit" className="pp-button" onClick={this.restoreSizingForm}>Restore Sizing Form</button>
					</div>
				);
			}
		}


		// convert lists to option lists for select element
		let salesUserOptions = [];
		for(let i=0; i<salesUserList.length; i++) {
			salesUserOptions.push({
				value: salesUserList[i].pp_user_id,
				text: salesUserList[i].first_name + " " + salesUserList[i].last_name
			});
		}

		let configurationList = [];
		let recommendedConfig = {
			ConfigSeakeepers: []
		};
		let recommendedIndex = 1;
		let configCount = (this.state.configurations) ? this.state.configurations.length : 0;
		for(let i=0; i<configCount; i++) {
			configurationList.push(this.state.configurations[i]);
		}

		configCount = configurationList.length;
		for(let i=0; i<configCount; i++) {
			if(configurationList[i].recommended === "1" || configurationList[i].recommended === 1) {
				recommendedConfig = configurationList[i];
				recommendedIndex = i;
			}
		}

		// sort the configurations by angular momentum
		let sort = true,
			sortedConfigInfo = JSON.parse(JSON.stringify(this.state.configInfo));

		console.log('state configs', this.state.configurations);
		console.log('state configinfo', this.state.configInfo);
		console.log('sorted', sortedConfigInfo);
		
		for (let a = 0; a < sortedConfigInfo.length; a += 1) {
			sortedConfigInfo[a].index = a;
		}

		while (sort) {
			sort = false;
			for(let i=0; i < configCount - 1; i++) {
				let count, count2, total, total2, temp = 0, temp2 = 0;
				
				if (sortedConfigInfo[i] === undefined) {
					sortedConfigInfo.splice(i, 1);
					i -= 1;
					configCount -= 1;
				}

				count = configurationList[i].ConfigSeakeepers.length;
				count2 = configurationList[i+1].ConfigSeakeepers.length;
				total = configurationList[i].TotalDeltaPhi;
				total2 = configurationList[i+1].TotalDeltaPhi;
				temp = 0;
				temp2 = 0;
				
				for (let a = 0; a < count; a += 1) {
					total += ((configurationList[i].ConfigSeakeepers[a].angular_momentum * 1) * (configurationList[i].ConfigSeakeepers[a].sk_model_count * 1));
				}
				for (let a = 0; a < count2; a += 1) {
					total2 += ((configurationList[i+1].ConfigSeakeepers[a].angular_momentum * 1) * (configurationList[i+1].ConfigSeakeepers[a].sk_model_count * 1));
				}

				if (total < total2) {
					console.log('swap');
					temp = configurationList[i];
					configurationList[i] = configurationList[i+1];
					configurationList[i+1] = temp;

					temp2 = sortedConfigInfo[i];
					sortedConfigInfo[i] = sortedConfigInfo[i+1];
					sortedConfigInfo[i+1] = temp2;
					sort = true;

					// swap chart data
					temp = chartData.datasets[i].data;
					temp2 = chartData.datasets[i+1].data;
					chartData.datasets[i].data = temp2;
					chartData.datasets[i+1].data = temp;
				}
			}
		}
	

		// chart disclaimer
		let disclaimer = '';

		// catamarans only
		if (this.isCatamaran()) {
			if(this.state.vesselInfo.vesselUse === "Offshore") {
				disclaimer = (
					<div>
						<div className="pp-disclaimer catamaran-disclaimer">
							<p>Recommended - <br />80% reduction at {'>'} +/- 9 degrees</p>
							<p>Minimum - <br />80% reduction at {'>'} +/- 6 degrees</p>
							<div className="pp-disclaimer-line pp-catamaran-offshore"></div>
						</div>
					</div>
				);
			} else {
				disclaimer = (
					<div>
						<div className="pp-disclaimer catamaran-disclaimer">
							<p>Recommended - <br />80% reduction at {'>'} +/- 6 degrees</p>
							<p>Minimum - <br />80% reduction at {'>'} +/- 4 degrees</p>
							<div className="pp-disclaimer-line pp-catamaran-costal"></div>
						</div>
					</div>
				);
			}

		// all other boat types
		} else {
			if(this.state.vesselInfo.vesselUse === "Offshore") {
				disclaimer = (
					<div>
						<div className="pp-disclaimer requirements-legacy">
							<p>Recommended - <br />80% reduction at {'>'} +/- 15 degrees</p>
							<p>Minimum - <br />80% reduction at {'>'} +/- 10 degrees</p>
							<div className="pp-disclaimer-line pp-15-deg-offshore"></div>
						</div>
						<div className="pp-disclaimer requirements-2023">
							<p>Recommended - <br />80% reduction at {'>'} +/- 15 degrees</p>
							<p>Minimum - <br />80% reduction at {'>'} +/- 11 degrees</p>
							<div className="pp-disclaimer-line pp-15-deg-offshore"></div>
						</div>
					</div>
				);
			} else {
				disclaimer = (
					<div>
						<div className="pp-disclaimer requirements-legacy">
							<p>Recommended - <br />80% reduction at {'>'} +/- 10 degrees</p>
							<p>Minimum - <br />80% reduction at {'>'} +/- 6 degrees</p>
							<div className="pp-disclaimer-line pp-10-deg-costal"></div>
						</div>
						<div className="pp-disclaimer requirements-2023">
							<p>Recommended - <br />80% reduction at {'>'} +/- 11 degrees</p>
							<p>Minimum - <br />80% reduction at {'>'} +/- 7 degrees</p>
							<div className="pp-disclaimer-line pp-11-deg-costal"></div>
						</div>
					</div>
				);
			}
		}

		let newRequirements2023 = this.state.newRequirements2023 === true ? " new-requirements-2023" : "";
		let hullType = 'hull-type-' + this.state.vesselInfo.hullType;
		let pageClass = this.state.loading === true ? 'pp-sizing-form-page ' + unitClass + ' pp-loading' + ' ' + hullType : 'pp-sizing-form-page ' + unitClass + newRequirements2023 + ' ' + hullType;

		return (
			<Page
				pageTitle="Create Sizing Form"
				pageClass={pageClass}>

				{message &&
					<Popup body={message.body} title={message.title} actionButtons={message.actionButtons} />
				}

				<PageSection sectionTitle="Sizing Form" sectionActions={editButton}>
					<CustomerInfo user={customerInfo} />
					<div className="pp-form-wrapper pp-sales-select">
						<div className="pp-form-row-split">
							<Select
								type="text"
								htmlID="salesUser"
								htmlName="salesUser"
								label="Sales Representative"
								placeholderText="Sales Representative"
								value={this.state.selectedSalesUser}
								onChange={this.changeSalesUser}
								options={salesUserOptions}
								disabled={disableVessel}
								error={this.state.errors.selectedSalesUser || false}
							/>
						</div>
					</div>
					<BMYForm
						setBMY={this.setBMY}
						bmyInfo={bmyInfo}
						changeBuilder={this.changeBuilder}
						changeModel={this.changeModel}
						changeYear={this.changeYear}
						builderInfo={builderInfo}
						modelInfo={modelInfo}
						year={year}
						disableAll={disableBMY}
						error={this.state.errors.bmy_id || false}
					/>
					<ButtonGroup
						className="pp-units"
						options={['Metric', 'English']}
						selected={(this.state.unit === "Metric") ? 0 : 1}
						value={'Metric'}
						onChange={this.unitChange}
					/>
					<VesselForm
						bmyInfo={bmyInfo}
						vesselInfo={vesselInfo}
						onChange={this.vesselInfoChange}
						disableAll={disableVessel}
						hasOverride={this.state.hasOverride}
						originalValues={this.state.originalValues}
						errors={this.state.errors}
						units={this.state.unit}
						isCatamaran={this.isCatamaran()}
					/>
					<ConfigurationForm
						onChange={this.configInfoChange}
						configInfo={sortedConfigInfo}
						addConfigSeakeeper={this.addConfigSeakeeper}
						addConfiguration={this.addConfiguration}
						disableAddConfiguration={this.state.disableAddConfiguration}
						deleteConfiguration={this.deleteConfiguration}
						canRecommend={this.state.canRecommend || this.state.isEditingReportConfigs}
						canShowHide={this.state.canShowHide || this.state.isEditingReportConfigs}
						updateRecommendConfig={this.updateRecommendConfig}
						recommendedConfiguration={this.state.recommendedConfiguration}
						deleteConfigSeakeeper={this.deleteConfigSeakeeper}
						disableAll={(!this.state.isEditingConfigs && !this.state.isNew)}
						changeShowHide={this.configChangeShowHide}
						sizingCalculator={this.state.sizingCalculatorRec}
					/>
					{updateButtons}
					{(this.state.canApprove || this.state.canPublish || this.state.showChart) &&
						<div className="pp-line-chart-section">
							<div className="pp-chart-key">
								<h4 className="pp-config-title">Sizing Key</h4>
								{configurationList && configurationList.map((data, index) => (
									<div className="pp-key-group">
										<p className={"pp-key-title pp-key-" + (index + 1)}>Configuration {index + 1}</p>
										{data.ConfigSeakeepers.map(sk => (
											<dl className="pp-definition-list">
												<dt className="pp-title">{sk.sk_model_count}x</dt>
												<dd className="pp-definition"><img src={'https://api.seakeeper.com/' + sk.logo_url} className={'pp-sk-logo ' + (sk.seakeeper_model).replace(/ /g, "-").replace(/\./g, "-")} /></dd>
											</dl>
										))}
									</div>
								))}

							</div>
							{this.state.displayChart &&
								<div className="pp-line-chart">
									<p className="pp-chart-title">Roll Reduction at Zero Speed in Regular Beam Sea Waves at Natural Roll Period</p>
									<p className="pp-y-title">Percent Uncontrolled Roll Reduction - %</p>
									<p className="pp-x-title">Uncontrolled Roll Amplitude</p>
									{disclaimer}
									<LineChart data={chartData} options={this.state.chartOptions} width="640" height="350"/>
								</div>
							}
						</div>
					}
					{actionButtons}
				</PageSection>
			</Page>
		);
	}
}

export default SizingForm;



// WEBPACK FOOTER //
// ./src/components/pages/SizingForm.js